import DayOne from "./dayOne"
import DayTwo from "./dayTwo"
import DayThree from "./dayThree"
import onDemand from "./onDemand"

export default (d) => {
    const days = [
        DayOne, 
        DayTwo,
        DayThree,
        onDemand
    ]

    if (d && !days[d]) return {
        tvs: []
    }

    const day = d ? [days[d]] : days.filter(it => it.day <= new Date())
    if (day.length === 0) return DayOne

    return day.pop()
}